import { createFileRoute } from '@tanstack/react-router'
import { PropertyMappingRulesPage } from '../../../components/PropertyMappingRulesPage'

export const Route = createFileRoute('/$org/property-mapping-rules/')({
  component: PropertyMappingRulesPageRoute,
})

function PropertyMappingRulesPageRoute() {
  return <PropertyMappingRulesPage />
}
